<template>
<div >
    <div class="form-group">
        <label for="anno"><strong>{{label.toUpperCase()}}</strong></label>
        <select :id="season_year" :required="required" :disabled="!isActive" @change="$emit('update',year)" class="form-control" v-model="year" >
          <option v-if="optionBase" value="0"> -- Seleziona un anno -- </option>  
          <option v-for="(item,index) in items" :value="item.seasonYear" :key="index">{{item.seasonYear}}</option>        
        </select>  
      </div>  
</div>



</template>
<script>

import api from '@/api';
export default {
  props : ['isActive','required','optionBase','_year','_label','_id'] , 
  components: {},
  data() {
    return {

      year                   : 0,
      items                  : [],
      spinner                : false,
      label                  : this._label ? this._label + ' Anno' : 'Anno',
      season_year            : this._id ? 'season_year_' + this._id : 'season_year'

     
     
    };
  },
  mounted: function() {
  
  },
  created: function() {
      this.getData()
      

      //this.label = this._label ? this._label : 'Anno'
  },
  methods: 
  {
    async getData()
    {
            
      var json   = {'sp'  : 'spYearSelect'} 
      await api.post(json).then(res => {
          
         
          if(res.status==200)
            {
              this.items = res.data.recordsets[0]      
              this.year = this._year           
            }
           else if(res.status==500)
           {
                console.log(res.data)

                
                    
           } 
           else
            {
                console.log('Network Error.')                  
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          this.spinner = false
        });

      
    },
      
  
}

}
</script>
<style scoped>

</style>